
<div class="file-loader-grouped-list">
  <!-- Loading state -->
  <v-progress-linear
    v-if="loading"
    indeterminate
    color="primary"
    class="mb-4"
    aria-live="polite"
    aria-label="Loading file data"
  />

  <!-- Empty state -->
  <div v-if="!loading && Object.keys(groupedFiles).length === 0" class="text-center py-12">
    <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
    <div class="text-h6 grey--text mt-4">No files found</div>
    <div class="text-body-2 grey--text">Files will appear here once they are processed</div>
  </div>

  <!-- Grouped list -->
  <div v-if="!loading && Object.keys(groupedFiles).length > 0" class="grouped-list-container">
    <div
      v-for="(group, date) in groupedFiles"
      :key="date"
      class="date-group mb-4"
    >
      <!-- Date header -->
      <div class="date-header d-flex align-center justify-space-between mb-2">
        <h3 class="text-h6 font-weight-bold">
          {{ formatDateHeader(date) }}
        </h3>
        <v-chip small outlined class="file-count-chip">
          {{ group.length }} {{ group.length === 1 ? 'file' : 'files' }}
        </v-chip>
      </div>

      <!-- Files for this date -->
      <v-card outlined class="group-card">
        <v-list>
          <template v-for="(file, index) in group">
            <v-list-item
              :key="file.fileLoaderGuid"
              class="file-list-item"
              :class="{ 'file-list-item--failed': file.loadStatus === 'failed' }"
              :aria-label="`File: ${file.fileName}, Status: ${file.loadStatus}`"
              :data-testid="`grouped-file-${file.fileLoaderGuid}`"
            >
              <!-- File icon -->
              <v-list-item-avatar>
                <v-icon
                  :color="file.loadStatus === 'failed' ? 'error' : 'primary'"
                >
                  {{ file.loadStatus === 'failed' ? 'mdi-close-circle' : 'mdi-check-circle' }}
                </v-icon>
              </v-list-item-avatar>

              <!-- File content -->
              <v-list-item-content>
                <!-- File name and timestamp -->
                <v-list-item-title class="file-name-title">
                  {{ file.fileName }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ formatDateTime(file.loadedDate) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <!-- File type badge -->
              <div class="file-type-column">
                <file-loader-type-badge :file-type="file.fileType" />
              </div>

              <!-- Stats -->
              <div class="file-stats d-flex align-center">
                <div class="stat-column">
                  <div
                    class="stat-value"
                    :class="file.rowsAccepted > 0 ? 'success--text' : 'grey--text'"
                  >
                    {{ file.rowsAccepted.toLocaleString() }}
                  </div>
                  <div class="stat-label">Accepted</div>
                </div>
                <div class="stat-column">
                  <div
                    class="stat-value"
                    :class="file.rowsRejected > 0 ? 'error--text' : 'grey--text'"
                  >
                    {{ file.rowsRejected.toLocaleString() }}
                  </div>
                  <div class="stat-label">Rejected</div>
                </div>
                <div class="stat-column">
                  <div
                    class="stat-value"
                    :class="file.submissionsCreated > 0 ? 'primary--text' : 'grey--text'"
                  >
                    {{ file.submissionsCreated.toLocaleString() }}
                  </div>
                  <div class="stat-label">Submissions</div>
                </div>
                <div class="stat-column">
                  <div class="stat-value grey--text text--darken-1">
                    {{ formatDuration(file.durationSeconds) }}
                  </div>
                  <div class="stat-label">Duration</div>
                </div>
              </div>
            </v-list-item>

            <v-divider v-if="index < group.length - 1" :key="`divider-${file.fileLoaderGuid}`" />
          </template>
        </v-list>
      </v-card>
    </div>
  </div>
</div>
